import { Card } from '../../models/card.model';
import { User } from '../../models/user.model';

/**
 * Pano §1 "Sizi bekleyenler" sayimlari (saf mantik). Veri Pano'nun zaten yukledigi
 * kullanici/kart listelerinden gelir; yeni istek ya da uc yoktur.
 */

/**
 * Davet bekliyor mu: Kullanicilar (§2) durum cipiyle ayni kural. Inactive olsa da davet tarihi
 * varsa kod gitmistir -> "davet bekliyor"; tarihsiz Inactive henuz davet edilmemistir.
 */
export function isInvitePending(user: Pick<User, 'status' | 'date'>): boolean {
    if (user.status === 'Active') return false;
    return user.status === 'Pending' || !!user.date;
}

/**
 * Kodu yeniden gonderilebilecek davetliler. Anahtarla acilan (locked) kayitta ad/e-posta
 * cozulmemistir; gonderim yapilamaz, bu kayit "anahtarla acilan" satirinda sayilir.
 */
export function pendingInviteUsers(users: User[] | null | undefined): User[] {
    return (users ?? []).filter(u => !!u.id && !!u.email && !u.locked && isInvitePending(u));
}

/**
 * Kimseye atanmamis kart sayisi: Kartlar listesi "Atanmamis" cipiyle ayni kural
 * (bkz. CardsComponent.matchesCardFilter / pendingCardIds). Davetliye on-atanmis kart sayilmaz.
 */
export function unassignedCardCount(cards: Card[] | null | undefined, users: User[] | null | undefined): number {
    const pending = new Set(
        (users ?? []).filter(u => u.status !== 'Active' && !u.username && !!u.pendingCardId).map(u => u.pendingCardId!)
    );
    return (cards ?? []).filter(c => !c.assignedToUser?.trim() && !pending.has(c.id)).length;
}

/** Bilgisi anahtarla acilan (bu oturumda cozulemeyen) kullanici sayisi. */
export function lockedUserCount(users: Pick<User, 'locked'>[] | null | undefined): number {
    return (users ?? []).filter(u => !!u.locked).length;
}
